import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API_BASE_URL from "../config/api";

export default function TopCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch(
          `${API_BASE_URL}/book_categories.php`
        );

        if (!res.ok) {
          throw new Error("API request failed");
        }

        const contentType = res.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
          throw new Error("Response is not JSON");
        }

        const data = await res.json();

        if (data?.success && Array.isArray(data.categories)) {
          const formatted = data.categories.map((cat) => ({
            id: cat.category_id,
            top_cat: cat.top_cat,
            title: cat.category_name || "Untitled Category",
            image:
              cat.picture_url && cat.picture_url.trim() !== ""
                ? cat.picture_url
                : `${process.env.PUBLIC_URL}/assets/img/subject-placeholder.jpg`,

            // ✅ FIXED QUESTION COUNT (handles all cases)
            questions: Number(
              cat.total_questions ??
                cat.question_count ??
                cat.questions ??
                cat.total ??
                0
            ),
          }));

          setCategories(formatted);
        } else {
          setCategories([]);
          setError("No categories found");
        }
      } catch (err) {
        console.error("Category fetch error:", err);
        setError("Failed to load categories");
        setCategories([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  return (
    <section className="pt-5 pb-5 bg-light">
      <div className="container">
        {/* HEADER */}
        <div className="row justify-content-center mb-4">
          <div className="col-lg-8 text-center">
            <h2 className="fw-bold mb-2 mt-4">Explore Top Categories</h2>
           
          </div>
        </div>

        {/* LOADING */}
        {loading && (
          <div className="text-center py-5 fw-semibold text-muted">
            Loading test categories...
          </div>
        )}

        {/* ERROR */}
        {!loading && error && (
          <div className="alert alert-warning text-center">{error}</div>
        )}

        {/* EMPTY STATE */}
        {!loading && !error && categories.length === 0 && (
          <div className="text-center py-5 text-muted">
            No test categories available
          </div>
        )}

        {/* CATEGORY CARDS */}
        <div className="row gx-3 gy-3">
          {categories.filter((cat) => cat.top_cat === '1').map((cat) => (
            <div key={cat.id} className="col-6 col-md-6 col-lg-4">
              <div className="">
                {/* IMAGE */}
              <Link
                      to="/subscription">
                        <img
                  src={`${process.env.PUBLIC_URL}${cat.image}`} 
                  alt={cat.title}
                  className="card-img-top"
                /></Link>

                
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
